import React, { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const KXParticles = () => {
  const init = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const options = {
    fpsLimit: 60,
    fullScreen: { enable: false },
    detectRetina: true,
    background: { color: "transparent" },
    particles: {
      number: { value: 40, density: { enable: true, area: 900 } },
      color: { value: ["#FF9933", "#FFD700", "#ffffff"] },
      opacity: { value: { min: 0.05, max: 0.35 } },
      size: { value: { min: 0.4, max: 1.8 } },
      move: {
        enable: true,
        direction: "top",
        outModes: { default: "out" },
        speed: { min: 0.15, max: 0.55 },
        random: true,
        straight: false,
      },
      shape: { type: "circle" },
    },
  };

  return (
    <div className="pointer-events-none fixed inset-0 z-[1]" aria-hidden>
      <Particles id="kx-particles" init={init} options={options} />
    </div>
  );
};

export default KXParticles;
